import React from 'react';
import IntegrationBlock from '../../index';
import moment from 'moment';
import StatusBlock from '../StatusBlock';
import TechData from '../TechData';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

const Wrapper = styled('div')`
  .marking-request {
    padding: 0 1.5rem;
  }
`;

const CargoMarking = (props) => {
  const { data, modalType, isSaveable, isChangeable } = props;

  return (
    <Wrapper>
      {data !== null && data !== undefined && (
        <>
          <IntegrationBlock
            title="Маркировка грузомест"
            isChangable={false}
            modalType={modalType}
            modalData={data}
            isSaveable={isChangeable}
          >
            <h5>Отправка грузомест</h5>
            {/*            <p>Код операции: {data?.techData?.cargoTechData?.supplyCargoOperationId}</p>
            <p>
              Дата выгрузки:{' '}
              {data?.techData?.cargoTechData?.supplyCargoRequestTs !== undefined
                ? moment(data?.techData?.cargoTechData?.supplyCargoRequestTs).format(
                    'DD.MM.YYYY HH:mm:ss',
                  )
                : 'Не установлена'}
            </p>
            <p>
              Дата ответа OZON:{' '}
              {data?.techData?.cargoTechData?.supplyCargoSyncResultTs !== undefined
                ? moment(data?.techData?.cargoTechData?.supplyCargoSyncResultTs).format(
                    'DD.MM.YYYY HH:mm:ss',
                  )
                : 'Не установлена'}
            </p>*/}
          </IntegrationBlock>
          <StatusBlock
            status={data.techData?.cargoTechData?.supplyCargoStatus}
            syncro={data.techData?.cargoTechData?.supplyCargoSynchronized}
            draftErrors={
              data.techData?.cargoTechData?.supplyCargoErrors !== undefined
                ? data.techData?.cargoTechData?.supplyCargoErrors[0]?.error_reasons[0]
                : ''
            }
          />
          <TechData
            code={data.techData?.cargoTechData?.supplyCargoOperationId}
            date={data.techData?.cargoTechData?.supplyCargoRequestTs || null}
            ozonDate={data.techData?.cargoTechData?.supplyCargoSyncResultTs}
          />
          <div className="marking-request">
            <h5>Запрос маркировки OZON</h5>
            {data?.supplyData?.supplyCargoLabel && (
              <a href={data?.supplyData?.supplyCargoLabel} rel="noopener noreferrer">
                Pdf-файл с маркировкой
              </a>
            )}

            {/*            <p>Код операции: {data?.techData?.cargoLabelTechData?.supplyCargoLabelOperationId}</p>
            <p>
              Дата выгрузки:{' '}
              {data?.techData?.cargoLabelTechData?.supplyCargoLabelRequestTs !== undefined
                ? moment(data?.techData?.cargoLabelTechData?.supplyCargoLabelRequestTs).format(
                    'DD.MM.YYYY HH:mm:ss',
                  )
                : 'Не установлена'}
            </p>
            <p>
              Дата ответа OZON:{' '}
              {data?.techData?.cargoLabelTechData?.supplyCargoLabelSyncResultTs !== undefined
                ? moment(data?.techData?.cargoLabelTechData?.supplyCargoLabelSyncResultTs).format(
                    'DD.MM.YYYY HH:mm:ss',
                  )
                : 'Не установлена'}
            </p>*/}
          </div>
          <StatusBlock
            status={data.techData?.cargoLabelTechData?.supplyCargoLabelStatus}
            syncro={data.techData?.cargoLabelTechData?.supplyCargoLabelSynchronized}
            draftErrors={
              data.techData?.cargoLabelTechData?.supplyCargoLabelErrors !== undefined
                ? data.techData?.cargoLabelTechData?.supplyCargoLabelErrors[0]
                : ''
            }
          />
          <TechData
            code={data.techData?.cargoLabelTechData?.supplyCargoLabelOperationId}
            date={data.techData?.cargoLabelTechData?.supplyCargoRequestTs || null}
            ozonDate={data.techData?.cargoLabelTechData?.supplyCargoLabelSyncResultTs}
          />
        </>
      )}
    </Wrapper>
  );
};

export default CargoMarking;
